import React, { useEffect } from "react";

const COLOR_MAP = {
  light_red: "#FDE8E8",
  light_blue: "#E6F0FF",
  light_green: "#E8F8F1",
  light_yellow: "#FFF7E0",
  light_purple: "#F1E8FF",
  light_orange: "#FFEBDD",
  light_pink: "#FFE6F1",
  light_brown: "#F5EDE6",
  light_gray: "#F5F5F5",
  dark_red: "#D14343",
  dark_blue: "#1F4DB3",
  dark_green: "#2F855A",
  dark_yellow: "#B7791F",
  dark_purple: "#553C9A",
  dark_orange: "#C05621",
  dark_pink: "#B83280",
  dark_brown: "#8B5E3C",
  dark_gray: "#4A5568",
  none: "transparent",
};

const SquareOffersSlider2 = ({ title, products, backgroundColor }) => {
  useEffect(() => {
    // Wait for DOM to be ready and Swiper to be available
    const initializeSlider = () => {
      if (!window.Swiper) {
        console.log("Swiper not available yet, retrying...");
        setTimeout(initializeSlider, 100);
        return;
      }

      // Initialize SquareOffersSlider2
      const sliderElement = document.querySelector(".tf-sw-product-sell");
      if (sliderElement) {
        // Destroy existing instance if it exists
        if (sliderElement.swiper) {
          try {
            sliderElement.swiper.destroy(true, true);
          } catch (e) {
            // no-op
          }
        }
        
        console.log("Initializing SquareOffersSlider2...");
        const preview = parseFloat(sliderElement.dataset.preview) || 4.6;
        const tablet = parseFloat(sliderElement.dataset.tablet) || 2.6;
        const mobile = parseFloat(sliderElement.dataset.mobile) || 2.5;
        const spacingLg = parseInt(sliderElement.dataset.spaceLg) || 30;
        const spacingMd = parseInt(sliderElement.dataset.spaceMd) || 15;
        const perGroup = parseInt(sliderElement.dataset.pagination) || 1;
        const perGroupMd = parseInt(sliderElement.dataset.paginationMd) || 1;
        const perGroupLg = parseInt(sliderElement.dataset.paginationLg) || 1;

        console.log("Mobile slidesPerView:", mobile);

        new window.Swiper(".tf-sw-product-sell", {
          slidesPerView: mobile,
          spaceBetween: spacingMd,
          speed: 1000,
          pagination: {
            el: ".sw-pagination-product",
            clickable: true,
          },
          slidesPerGroup: perGroup,
          navigation: {
            clickable: true,
            nextEl: ".nav-next-product",
            prevEl: ".nav-prev-product",
          },
          breakpoints: {
            768: {
              slidesPerView: tablet,
              spaceBetween: spacingLg,
              slidesPerGroup: perGroupMd,
            },
            1150: {
              slidesPerView: preview,
              spaceBetween: spacingLg,
              slidesPerGroup: perGroupLg,
            },
          },
          watchOverflow: true,
          observer: true,
          observeParents: true,
        });
        console.log("SquareOffersSlider2 initialized successfully");
      }
    };

    initializeSlider();
  }, []);

  const resolvedBg =
    backgroundColor && COLOR_MAP[backgroundColor]
      ? COLOR_MAP[backgroundColor]
      : backgroundColor && /^#|rgb|hsl/.test(backgroundColor)
      ? backgroundColor
      : undefined;

  return (
    <>
      <style>
        {`
          /* Blue hover effect for product titles */
          .collection-item.style-2 .collection-content .collection-title {
            transition: color 0.3s ease;
          }
          
          .collection-item.style-2:hover .collection-content .collection-title {
            color: #0e5aa7 !important;
          }
          
          /* Make bluish border always visible */
          .tf-sw-product-sell .collection-item.style-2 .collection-image {
            border-color: #0e5aa7 !important;
            outline-color: #0e5aa7 !important;
            outline: 1px solid #0e5aa7 !important;
            border: 1px solid #0e5aa7 !important;
          }
          
          /* Enhance border on hover */
          .tf-sw-product-sell .collection-item.style-2:hover .collection-image,
          .tf-sw-product-sell .collection-item.style-2 .collection-image:hover,
          .tf-sw-product-sell .collection-item.style-2 .collection-image:focus,
          .tf-sw-product-sell .collection-item.style-2 .collection-image:focus-visible {
            border-color: #0a4a8a !important;
            outline-color: #0a4a8a !important;
            outline: 2px solid #0a4a8a !important;
            border: 2px solid #0a4a8a !important;
          }
          
          /* Adjust items for mobile - ensure correct width for 2.5 items */
          @media (max-width: 767px) {
            .tf-sw-product-sell .swiper-slide {
              width: calc((100% - 30px) / 2.5) !important;
              flex-shrink: 0 !important;
              margin-right: 15px !important;
            }
            
            .tf-sw-product-sell .collection-item.style-2 {
              width: 100%;
              min-width: 0;
            }
          }
        `}
      </style>
      <section
        className="flat-spacing-9"
        style={resolvedBg ? { backgroundColor: resolvedBg } : undefined}
      >
        <div className="container">
          <div className="flat-title flex-row justify-content-between px-0">
            {title && (
              <span
                className="title wow fadeInUp font-sora fw-6"
                data-wow-delay="0s"
              >
                {title}
              </span>
            )}
          </div>
        </div>
        <div className="container-full slider-layout-right">
          <div
            dir="ltr"
            className="swiper tf-sw-product-sell sw-wrapper-right"
            data-preview="4.6"
            data-tablet="2.6"
            data-mobile="2.5"
            data-space-lg="30"
            data-space-md="15"
            data-pagination="1"
            data-pagination-md="1"
            data-pagination-lg="1"
          >
            <div className="swiper-wrapper">
              {products.map((product, index) => (
                <div key={index} className="swiper-slide">
                  <div className="collection-item style-2 hover-img">
                    <div className="collection-inner">
                      <a
                        href={product.link || "/shop-collection-sub"}
                        className="collection-image img-style d-flex"
                      >
                        <img src={product.image} alt={product.name} />
                      </a>
                      <div className="collection-content collection-content-before">
                        <a
                          href={product.link || "/shop-collection-sub"}
                          className="tf-btn collection-title hover-icon fs-20 rounded-full font-sora"
                        >
                          <span>{product.name}</span>
                          <i className="icon icon-arrow1-top-left"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SquareOffersSlider2;
